import { render } from "./Index-elecBoard.vue?vue&type=template&id=d513d62c"
import script from "./Index-elecBoard.vue?vue&type=script&lang=js"
export * from "./Index-elecBoard.vue?vue&type=script&lang=js"

import "./Index-elecBoard.vue?vue&type=style&index=0&id=d513d62c&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__